import React from 'react';
import { Link } from 'react-router-dom';

const SuccessPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h1>Success!</h1>
      <p style={{ paddingTop: '20px'}}>Thank you for registering with us. Your form has been successfully submitted.</p>
      <p style={{ paddingTop: '20px'}}>
        A representative will reach out to you shortly to complete the
        registration process.
      </p>
      <div style={{ padding: '14px'}}>
        <Link to='/' style={{ textDecoration: 'none', color: '#007bff' }}>
          Go back to add another customer
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
